import { TFrequencyRecord } from "../../../../types/dto/FrequencyRecordDto";
import { FrequencyRecordRaw } from "../../../../types/FrequencyRecord";
import { dateService } from "../../../../services/date";

const mapFrequencyRecordsDtoToFrequencyRecords = (
  frequencyRecords: Array<TFrequencyRecord>
): Array<FrequencyRecordRaw> =>
  frequencyRecords.map(
    ({ AreaID, Value, ReportPeriod, CollectionDate, WeekEnding }) => {
      try {
        return {
          areaID: AreaID,
          value: Number(Value),
          reportPeriod: dateService.parseApiDate(ReportPeriod),
          collectionDate: CollectionDate ? dateService.parseApiDate(CollectionDate) : new Date(NaN),
          weekEnding: WeekEnding ? dateService.parseApiDate(WeekEnding) : undefined,
        };
      } catch (error) {
        console.error('Error parsing frequency record dates:', error, { ReportPeriod, CollectionDate, WeekEnding });
        return {
          areaID: AreaID,
          value: Number(Value),
          reportPeriod: new Date(ReportPeriod),
          collectionDate: new Date(CollectionDate),
          weekEnding: WeekEnding ? new Date(WeekEnding) : undefined,
        };
      }
    });

export default mapFrequencyRecordsDtoToFrequencyRecords;
